<div class="editor">
  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
        <!-- Nội dung chữ -->
        <div class="field-row">
          <mat-form-field style="width: 95%">
            <mat-label>Số cần hiển thị</mat-label>
            <input style="width: 100% !important" matInput
              oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');"
              [(ngModel)]="objectChoosing.staticdata.content" class="input-parameter" (blur)="updateStaticData()" >
          </mat-form-field>
        </div>
        <!-- Thời gian hiệu ứng -->
        <div class="config-name">
          <p class="m-0" style="line-height:1.5">Thời gian hiệu ứng(s)</p>
          <nz-input-number style="width:40%" [(ngModel)]=" config.animation_text.animation_duration
            " (ngModelChange)="updateConfig() " [nzMin]="0" [nzMax]="5" [nzStep]="0.1" class="input-parameter">
          </nz-input-number>
        </div>
    </div>
  </ng-container>
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- HIỂN THỊ -->
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <div class="editor-field">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
      <!-- Cấu hình tái sử dụng thiết kế-->
      
      <!-- CHỮ VÀ ĐỊNH DẠNG-->
      <li nz-submenu nzTitle="{{'chu_va_dinh_dang' | translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <div class="editor-field">
          <div class="editor-field-body">
            <div class="field-row">
              <!-- Nội dung chữ -->
              <div class="field-row">
                <mat-form-field style="width: 95%">
                  <mat-label>Số cần hiển thị</mat-label>
                  <input style="width: 100% !important" matInput
                    oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');"
                    [(ngModel)]="objectChoosing.staticdata.content" class="input-parameter" (blur)="updateStaticData()" >
                </mat-form-field>
              </div>
              <!-- Thời gian hiệu ứng -->
              <div class="config-name">
                <p class="m-0" style="line-height:1.5">Thời gian hiệu ứng(s)</p>
                <nz-input-number style="width:40%" [(ngModel)]=" config.animation_text.animation_duration
                  " (ngModelChange)="updateConfig() " [nzMin]="0" [nzMax]="5" [nzStep]="0.1" class="input-parameter">
                </nz-input-number>
              </div>
            </div>

            <app-text-format-config
                    [device]="device"
                    [objectChoosing]="objectChoosing"
                    [class]="class"
                    [config]="config"
                    [staticdata]="staticdata"
                    [textContentClass]="class['text__content']"
                    [textWrapperClass]="class['text__content']"
                    >
            </app-text-format-config>
            <div class="field-row">
              <div class="config-font">
                <!-- Độ đậm -->
                <div class="my-3">
                  <div class="config-name mb-0">
                    <p>{{'do_dam' | translate}}</p>
                    <nz-input-number [nzMin]="100" [nzMax]="900" [nzStep]="100"
                      [(ngModel)]="class['text__content']['font-weight']" (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="100" [nzMax]="900" [nzStep]="100"
                        [(ngModel)]="class['text__content']['font-weight']" (nzOnAfterChange)="updateClass()">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
              </div>
              <!-- Gradient -->
              <div class="config-font">
                <div class="config-name">
                  <p>Đổ màu gradient <span style="font-size:13px">(đa sắc)</span></p>
                  <nz-switch [(ngModel)]="config['background-image']['gradient_check']"
                    (ngModelChange)="handleSetGradientText()">
                  </nz-switch>
                </div>
                <div class="container-gradient" *ngIf="config['background-image']['gradient_check']">
                  <div class="list-gradient">
                    <button class="btn-gradient"
                      *ngFor="let bgGradient of config['background-image']['background_image_arr_gradient']; let i = index"
                      (click)="deleteGradient(i)" [ngStyle]="{'backgroundColor': bgGradient}"
                      [disabled]="!config['background-image']['gradient_check']">
                      <i class="delete-icon bi bi-x-circle"></i>
                    </button>
                  </div>
                  <p class="title-head">{{ 'them_mau' | translate }}</p>
                  <div class="container_add-gradient">
                    <button class="btn-add-gradient" nz-tooltip nzTooltipTitle="{{ 'them_mau' | translate }}"
                      [disabled]="!config['background-image'].gradient_check" (click)="openbgGradient()"
                      (blur)="addGradient()">
                      <input nz-input type="color" class="picking-gradient" id="input-gradient"
                        [(ngModel)]="config['background-image']['background_image_background_color']">
                      <span class="plus-icon" nz-icon nzType="plus" nzTheme="outline"></span>
                    </button>
                    <div class="slide_container-gradient">
                      <input type="range" min="1" max="100"
                        [value]="config['background-image']['background_image_opacity']" class="slider-gradient"
                        (input)="getValueRangeBackgroundGradient($event)"
                        [disabled]="!config['background-image'].gradient_check"
                        [ngStyle]="{background: 'linear-gradient(to right, transparent,#2764EB,#EFE810), url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==)'}">
                    </div>
                    <div class="value-range">{{config['background-image']['background_image_opacity']}}%</div>
                  </div>
                  <p class="title-head">{{ 'huong_phoi_mau' | translate }}</p>
                  <button class="gradient-direction" *ngFor="let type of typeGradient" nz-tooltip
                    [nzTooltipTitle]="type.name" (click)="chooseOption(type, $event)"
                    [disabled]="!config['background-image'].gradient_check"
                    [style.background]="'linear-gradient('+ type.deg +', #2764EB, #EFE810)'"
                    [ngClass]="{ 'active': config['background-image']['background_image_direction'] === type.direction}">
                  </button>
                </div>
              </div>
            </div>
            <div class="field-row">
              <div class="config-font" style="margin-top:20px">
                <!-- Khoảng cách chữ -->
                <div>
                  <div class="config-name mb-0">
                     <p>{{'khoang_cach_chu' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50"
                      [ngModel]="class['text__content']['letter-spacing'] | vhnumber"
                      (ngModelChange)="class['text__content']['letter-spacing'] = $event+'px'" (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0" [nzMax]="50"
                        [ngModel]="class['text__content']['letter-spacing'] | vhnumber"
                        (ngModelChange)="class['text__content']['letter-spacing'] = $event+'px'"
                        (nzOnAfterChange)="updateClass()">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
                <!-- Khoảng cách dòng -->
                <div>
                  <div class="config-name mb-0">
                     <p>{{'khoang_cach_dong' | translate}}</p>
                    <nz-input-number [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1"
                      [(ngModel)]="this.class['text__content']['line-height']" (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1"
                        [(ngModel)]="this.class['text__content']['line-height']" (nzOnAfterChange)="updateClass()">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
                <!-- Độ nghiêng chữ -->
                <div>
                  <div class="config-name mb-0">
                    <p>{{'xoay_chu' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="360" [nzStep]="1" [(ngModel)]="config['transform']['rotate']"
                      (ngModelChange)="handleSetTextRotate()" (nzBlur)="updateClass(); updateConfig()">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0" [nzMax]="360" [nzStep]="1" [(ngModel)]="config['transform']['rotate']"
                        (ngModelChange)="handleSetTextRotate()" (nzOnAfterChange)="updateClass(); updateConfig()">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
                <ng-container *ngIf="config['transform']['rotate'] > 0">
                  <!-- Ẩn chữ -->
                  <div>
                    <div class="config-name mb-0">
                      <p>{{'an_chu' | translate}}</p>
                      <nz-switch [ngModel]="class.text.overflow == 'hidden'"
                      (ngModelChange)="class.text.overflow = $event ? 'hidden' : 'visible'; updateClass()">
                      </nz-switch>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </li>
      <!-- PHONG CÁCH VÀ KIỂU CỌ -->
      <li nz-submenu nzTitle="{{'phong_cach_va_kieu_co' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <app-text-style-config
                [device]="device"
                [config]="config"
                [class]="class"
                [textContentClass]="class['text__content']"
                [textWrapperClass]="class['text__content']"
                [filterConfig]="config['filter']"
                [isShape]="false"
                [objectChoosing]="objectChoosing">

        </app-text-style-config>
      </li> 
      <!-- Cấu hình xoay-->
      <li nz-submenu nzTitle="{{'cau_hinh_xoay' | translate}}" [(nzOpen)]="openMap.menu9"
        (nzOpenChange)="openHandler('menu9')">
        <app-rotate-config [classRotate]="class['text']" [config]="config" [device]="device"  [objectChoosing]="objectChoosing" ></app-rotate-config>
      </li>
      <!-- HIỆU ỨNG -->
      <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
        <app-choose-animations-config
          (openAnimationDetail)="openAnimationDetail($event)"
          [id_object]="objectChoosing._id"
          [elementChoosing]="objectChoosing"
          [device]="device"
          [class]="class"
          [config]="config"
          [staticdata]="staticdata"
          [cursorClass]="class['text']"
          [effect_hover]="effect_hover"
          [customize]="customize">
        </app-choose-animations-config>
      </li>

    </ul>
  </ng-container>

  <!-- CẤU HÌNH CHI TIẾT -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="this.config['animation-selected'].id != '000000'">
       <app-animations-config [type]="type" [elementChoosing]="objectChoosing" [device]="device" [staticdata]="staticdata" [id_object]="objectChoosing._id"
        [customize]="customize"></app-animations-config>
    </div>
  </div>
</div>
